import { atom } from "jotai";

import { currentBookingAtom } from "../../stores";

type RemoveMemberHoldOrUnknownGuestPayload =
  | "memberHold"
  | "unknownGuest"
  | {
      clientType: "memberHold" | "unknownGuest";
      bookingIndex?: number;
    };

export const removeMemberHoldOrUnknownGuestAtom = atom(
  null,
  (get, set, payload: RemoveMemberHoldOrUnknownGuestPayload) => {
    const booking = get(currentBookingAtom);
    if (!booking) {
      //@TODO: this is an error
      return;
    }

    const { clientType, bookingIndex } =
      typeof payload === "string" ? { clientType: payload } : payload;

    const roundIndex = booking.rounds?.findIndex(
      (round) =>
        round.player.clientType === clientType &&
        (bookingIndex == null || (round.bookingIndex ?? 0) === bookingIndex)
    );

    if (roundIndex !== undefined && roundIndex !== -1) {
      const filteredRounds = booking.rounds
        ?.filter((_, index) => index !== roundIndex)
        .map((r, i) => ({
          ...r,
          index: i,
        }));

      set(currentBookingAtom, {
        ...booking,
        rounds: filteredRounds,
      });
    }
  }
);
